export default [
  {
    name: 'overview',
    label: 'Overview',
    hideOnNavbar: true,
    component: () => import('./Steps/VenueOverviewStep'),
    navigation: {
      back: null,
      next: { label: 'Next', to: 'location' },
      skip: null,
    },
  },
  {
    name: 'location',
    label: 'Location',
    navbarIndex: 0,
    component: () => import('./Steps/VenueLocationStep'),
    navigation: {
      back: { label: 'Back', to: 'overview' },
      next: { label: 'Next', to: 'calendar' },
      skip: null,
    },
  },
  {
    name: 'calendar',
    label: 'Calendar',
    navbarIndex: 1,
    component: () => import('./Steps/VenueCalendarStep'),
    navigation: {
      back: { label: 'Back', to: 'location' },
      next: { label: 'Next', to: 'inventory' },
      skip: null,
    },
  },
  {
    name: 'inventory',
    label: 'Assets',
    navbarIndex: 2,
    component: () => import('./Steps/VenueInventoryStep'),
    navigation: {
      back: { label: 'Back', to: 'calendar' },
      next: { label: 'Next', to: 'preview' },
      skip: null,
    },
  },
  {
    name: 'inventory-create',
    label: 'Asset Create',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/InventoryCreateStep'),
    navigation: {
      back: { label: 'Back', to: 'inventory' },
      next: { label: 'Next', to: 'inventory' },
      skip: null,
    },
  },
  {
    name: 'sampling-space-edit',
    label: 'Sampling Space Edit',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/SamplingSpaceEditStep'),
    navigation: {
      back: { label: 'Back', to: 'inventory' },
      next: { label: 'Save', to: 'inventory' },
      skip: null,
    },
  },
  {
    name: 'onsite-space-edit',
    label: 'Onsite Space Edit',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/OnsiteSpaceEditStep'),
    navigation: {
      back: { label: 'Back', to: 'inventory' },
      next: { label: 'Save', to: 'inventory' },
      skip: null,
    },
  },
  {
    name: 'preview',
    label: 'Preview',
    navbarIndex: 3,
    component: () => import('./Steps/VenuePreviewStep'),
    navigation: {
      back: { label: 'Back', to: 'inventory' },
      finish: { label: 'Finish', to: null },
      skip: null,
    },
  },
  {
    name: 'advanced-settings',
    label: 'Advanced Settings',
    navbarIndex: 4,
    hideOnNavbar: true,
    component: () => import('./Steps/VenueAdvancedSettingsStep'),
    navigation: {
      back: { label: 'Back', to: 'preview' },
      next: { label: 'Next', to: 'preview' },
      skip: null,
    },
  },
]
